<template>
  <div class="third-Bar">
    <div class="bar-bottom">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        v-for="item in list.slice(3, 5)"
        :key="item.id"
        class="card"
      >
        <span class="category-alter">{{ item.sub_category.name }}</span>
        <div class="image-block">
          <ImageContainer
            :src="item.image.medium"
            :alt="item.title"
            :thumb="item.image.thumbnail"
            class="image"
          />
        </div>
        <div class="about">
          <span class="category">{{ item.sub_category.name }}</span>
          <h1 class="text">
            {{ item.title }}
          </h1>
          <h2 class="time">
            {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
          </h2>
        </div>
      </router-link>
    </div>
    <div class="bar-top">
      <router-link
        :to="$i18nRoute({ name: 'NewsDetail', params: { slug: item.url } })"
        v-for="item in list.slice(0, 3)"
        :key="item.id"
        class="card"
      >
        <div class="card-block">
          <span class="category">{{ item.sub_category.name }}</span>
          <div class="image-block">
            <ImageContainer
              :src="item.image.medium"
              :alt="item.title"
              :thumb="item.image.thumbnail"
              class="image"
            />
          </div>
          <div class="about">
            <span class="category-alter">{{ item.sub_category.name }}</span>
            <h1 class="text">
              {{ item.title }}
            </h1>
            <h2 class="time">
              {{ handleDate(item.pub_date) }}, {{ handleTime(item.pub_date) }}
            </h2>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import { useFormatter } from "@/utils/formatter";
import ImageContainer from "@/components/ImageContainer";
export default {
  name: "ThirddBar",
  components: {
    ImageContainer
  },
  props: {
    list: {
      type: Array,
      required: true
    }
  },
  setup() {
    return {
      ...useFormatter()
    };
  }
};
</script>
<style lang="scss" scoped>
.third-Bar {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: #fff;
  .bar-bottom {
    position: relative;
    background: #4b4d61;
    display: flex;
    justify-content: space-between;
    border-radius: 0 0 260px 260px;
    margin: 2% auto;
    width: 90%;
    .card {
      width: 40%;
      position: relative;
      margin: 2% 0;
      .category-alter {
        position: relative;
        font-family: Open Sans;
        font-weight: 600;
        font-size: 0.9em;
        opacity: 0.7;
        text-transform: uppercase;
        font-style: normal;
        line-height: 1;
        display: none;
        text-align: center;
      }
      .image-block {
        position: relative;
        width: 100%;
        // max-width: 689px;
        aspect-ratio: 689/420;
        .image {
          // max-width: 689px;
          position: relative;
          display: flex;
          align-items: center;
          width: 100%;
        }
      }
      .about {
        top: 0;
        position: absolute;
        background: rgba(75, 77, 97, 0.65);
        width: 60%;
        padding: 3% 5%;
        font-size: 2.2em;
        font-style: normal;
        line-height: 1;
        .category {
          position: relative;
          font-family: Open Sans;
          font-weight: 600;
          font-size: 0.9em;
          opacity: 0.7;
          text-transform: uppercase;
        }
        .text {
          font-family: Roboto;
          position: relative;
          font-weight: 600;
          --snup: 2;
          display: -webkit-box;
          -webkit-line-clamp: var(--snup);
          -webkit-box-orient: vertical;
          overflow: hidden;
          margin: 2% 0;
          font-size: 1em;
        }
        .time {
          font-family: Source Serif Pro;
          position: relative;
          font-weight: normal;
          opacity: 0.7;
          font-size: 1em;
        }
      }

      &:nth-child(1) {
        margin-left: 6%;
        .image-block {
          .image {
            border-radius: 0 0 0 210px;
          }
        }
        .about {
          text-align: end;
          right: 0;
          border-radius: 0 0 0 109px;
        }
      }
      &:nth-child(2) {
        margin-right: 6%;
        .image-block {
          .image {
            border-radius: 0 0 210px 0;
          }
        }
        .about {
          text-align: start;
          left: 0;
          border-radius: 0 0 109px 0;
        }
      }
    }
  }
  .bar-top {
    text-align: center;
    display: flex;
    justify-content: space-between;
    width: 80%;
    margin: 0 auto;
    position: relative;
    .card {
      position: relative;
      min-width: calc(100% / 3);
      color: #fff;
      // max-width: 454px;
      display: flex;
      flex-direction: column;
      align-items: center;
      .card-block {
        position: relative;
        width: 80%;
        background: #4b4d61;
        border-radius: 250px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .category {
          position: relative;
          font-family: Open Sans;
          font-style: normal;
          font-weight: 600;
          font-size: 2em;
          line-height: 1.1;
          opacity: 0.7;
          text-transform: uppercase;
          margin: 2% 0;
        }
        .image-block {
          position: relative;
          width: 110%;
          // max-width: 454px;
          .image {
            // max-width: 454px;
            position: relative;
            display: flex;
            align-items: center;
            width: 100%;
            aspect-ratio: 454/283;
            border-radius: 250px;
          }
        }
        .about {
          position: relative;
          width: 100%;
          font-size: 2.2em;
          font-style: normal;
          line-height: 1.5;
          margin: 0.6rem 0;
          .category-alter {
            display: none;
            position: relative;
            font-family: Open Sans;
            font-style: normal;
            font-weight: 600;
            font-size: 0.8em;
            line-height: 1.3;
            opacity: 0.7;
            text-transform: uppercase;
          }
          .text {
            font-family: Roboto;
            position: relative;
            font-weight: 600;
            --snup: 3;
            display: -webkit-box;
            -webkit-line-clamp: var(--snup);
            -webkit-box-orient: vertical;
            overflow: hidden;
            margin: 0 10%;
          }
          .time {
            font-family: Source Serif Pro;
            position: relative;
            font-weight: normal;
            opacity: 0.7;
            margin: 0.5rem 20%;
          }
        }
        .decor-line-sm {
          display: none;
        }
      }
    }

  }
}
@media screen and (max-width: 2900px) {
  .third-Bar {
    .bar-top {
      .card {
        .card-block {
          border-radius: 8.84em;
          .category {
            font-size: 1.2em;
          }
          .image-block {
            width: 115%;
            .image {
              border-radius: 141.5px;
            }
          }
          .about {
            font-size: 1.3em;
          }
          .decor-line-sm {
            display: none;
          }
        }
      }
    }
    .bar-bottom {
      .card {
        .image-block {
          aspect-ratio: 689/420;
        }
        .about {
          font-size: 1.2em;
        }
        .decor-line-sm {
          display: none;
        }
      }
    }
  }
}
@media screen and (max-width: 1920px) {
  .third-Bar {
    .bar-bottom {
      .card {
        .image-block {
          max-width: 689px;
        }
        .about {
          font-size: 1em;
          // .category {
          //   font-size: 0.9em;
          // }
          // .text {
          //   font-size: 1em;
          // }
          // .time {
          //   font-size: 1em;
          // }
        }
      }
    }
    .bar-top {
      .card {
        max-width: 454px;
        .card-block {
          border-radius: 8.84em;
          .category {
            font-size: 1.1em;
          }
          .image-block {
            width: 115%;
            max-width: 454px;
            .image {
              // max-width: 454px;
              border-radius: 141.5px;
            }
          }
          .about {
            font-size: 1.1em;
          }
          .decor-line-sm {
            display: none;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 978px) {
  .third-Bar {
    // background-color: #60657d;
    padding-top: 1rem;
    .bar-top {
      width: 100%;
      .card {
        .card-block {
          border-radius: 74px;
          .category {
            position: absolute;
            top: -8%;
            font-size: 0.9em;
          }
          .image-block {
            aspect-ratio: 236/162;
            border-radius: 150px;
            max-width: 236px;
          }
          .about {
            margin: 0.4rem 0;
            .text {
              font-size: 0.9em;
              margin: 0 5%;
            }
            .time {
              font-size: 0.9em;
              margin: 0.3rem 15%;
            }
          }
        }
      }
    }
    .bar-bottom {
      border-radius: 9.3em 0 0 9.3em;
      margin: 2% 0 4% auto;
      width: 98%;
      justify-content: space-around;
      .card {
        max-width: 326px;
        width: 50%;
        margin: 1% 1% !important;
        .category-alter {
          display: block;
          margin-bottom: 2%;
        }
        .image-block {
          max-width: 326px;
          aspect-ratio: 326/224;
          // border-radius: 150px;
          .image {
            border-radius: 150px !important;
          }
        }
        .about {
          position: relative;
          width: 80%;
          background: none;
          text-align: center !important;
          padding: 1% 0;
          margin: 0 auto;
          line-height: 1.2;
          .category {
            display: none;
          }
          .text {
            --snup: 3;
          }
        }

        &:nth-child(1) {
          margin-left: 2% !important;
        }
      }
    }
  }
}
@media screen and (max-width: 775px) {
  .third-Bar {
    .bar-bottom {
      .card {
        &:nth-child(1) {
          margin-left: 5% !important;
        }
        .about {
          width: 75%;
        }
      }
    }
  }
}
@media screen and (max-width: 475px) {
  .third-Bar {
    .bar-bottom {
      background: none;
      border-radius: 0;
      width: 100%;
      .card {
        width: 45%;
        margin: 0 !important;
        background: #56596f;
        border-radius: 55px 65px 65px 55px;
        .category-alter {
          display: none;
        }
        .image-block {
          aspect-ratio: 170/122;
          width: 105%;
          max-width: 210px;
          left: 50%;
          transform: translateX(-50%);
          // min-width: 100%;
          .image {
            border-radius: 287.5px;
          }
        }
        .about {
          width: 100%;
          max-width: 229px;
          .category {
            display: block;
            margin: 3% 0;
          }
          .text {
            --snup: 3;
            margin: 0 3%;
          }
          .time {
            margin: 5% 0 10% 0;
          }
        }
        &:nth-child(1) {
          margin-left: 0 !important;
        }
      }
    }
    .bar-top {
      flex-wrap: wrap;
      justify-content: space-between;
      .card {
        background: none;
        .card-block {
          background: none;
          position: relative;
          border-radius: 0;
          width: 100%;
          .category {
            display: none;
          }
          .about {
            .category-alter {
              display: block;
            }
            .text {
              --snup: 3;
            }
          }
        }
        &:nth-child(1) {
          min-width: 96%;
          max-width: 96%;
          background: #fff;
          margin-bottom: 4%;
          border-radius: 0px 0px 75.5px 0px;
          .card-block {
            flex-direction: row;
            justify-content: space-around;
            margin: 4% 0;
            .image-block {
              aspect-ratio: 169/126;
              width: 45%;
              max-width: 45%;
              min-width: 45%;
              border-radius: 0 0 63px 0;
              .image {
                border-radius: 0 0 63px 0;
              }
            }
            .about {
              width: 45%;
              color: #121212;
              .text {
                margin: 3% 0;
              }
              .time {
                opacity: 0.6;
              }
            }
          }
        }
        &:nth-child(2) {
          min-width: 42%;
          max-width: 42%;
          margin-left: 3%;
          .card-block {
            .image-block {
              aspect-ratio: 148/111;
              width: 100%;
              .image {
                aspect-ratio: 148/111;
                border-radius: 55.5px 0;
              }
            }
            .about {
              width: 100%;
            }
          }
        }
        &:nth-child(3) {
          min-width: 42%;
          max-width: 42%;
          margin-right: 3%;
          .image-block {
            width: 100%;
            aspect-ratio: 148/111;
            .image {
              border-radius: 0 55.5px;
              aspect-ratio: 148/111;
            }
          }
          .about {
            width: 100%;
          }
        }
      }
    }
  }
}
</style>
